import React from "react";
import { useQuery } from "react-query";
import { getJobDetailsById } from "../../../../actions/Utilities/JobConfig";

const useGetJobDetailsById = (args) => {
  return useQuery(["getJobDetailsById", args], () => getJobDetailsById(args), {
    refetchOnWindowFocus: false,
  });
};

export default useGetJobDetailsById;
